<div class="w-12 social-login">
    <p class="h4 left m-t-10 m-t-6-s m-b m-b-0-s">{{'Or log in with your social profile' | translate}}</p>
    <div class="flex-column">
        @for (social of socialLogin; track $index) {
        @if (social.valid) {
        <action class="button w-12 m-t-6"
                [ngClass]="'button-'+ social.serviceName"
                [class.bg-col-52]="status.busy"
                [status]="status"
                (click)="login(social.serviceName)">
            <div class="flex flex-middle">
                <i class="social-icon m-r-3"
                   [ngClass]="'login-'+ social.serviceName"></i>
                <span class="p1">{{'Sign in with' | translate}} {{social.serviceName.charAt(0).toUpperCase() +
                    social.serviceName.slice(1)}}</span>
            </div>
        </action>
        }
        }
    </div>

    <result class="m-t-1 block"
            [status]="status"></result>
</div>
